import { Component } from '@ecs/Component';

export class RailgunWeapon implements Component {
  readonly type = 'RailgunWeapon';

  constructor(
    public cooldown: number = 4000,
    public range: number = 300,
    public energyCost: number = 20,
    public bulletSpeed: number = 30, // Faster bullet
    public bulletColor: string = '#ff00ff',
    public damage: number = 3, // More damage
    public lastShot: number = 0,
    public chargeTime: number = 1000, // Time to charge before firing
    public isCharging: boolean = false,
    public chargeStartTime: number = 0,
    public aimAngle: number = 0
  ) {}
}